import React, { Component } from 'react';
import PropTypes from 'prop-types';


import classNames from 'classnames';
import Paper from '@mui/material/Paper';
import {grey} from '@mui/material/colors';
import { Box, Button } from '@mui/material';
import {getIcon} from '../../base';


const s:any = {
  paper: {
    flex: 1,
  },
  button: {
    width: '100%',
    justifyContent: 'start',
    alignItems: 'center'
  },
  iconSpan: {
    float: 'left',
    // display:'flex',
    // justifyContent:'center',
    // alignItem:'center',
    height: 60,
    width: 60,
    textAlign: 'center',
    borderRadius:16,
    marginRight:10
    //backgroundColor: theme.color
  },
  icon: {
    height: 48,
    width: 48,
    marginTop: 20,
    fill: 'white',
    maxWidth: '100%',
    color:'white'
  },
  content: {
    padding: '5px 5px',
    marginLeft: 90,
    // marginTop: 'auto',
    height: 80,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    alignContent: 'space-around'
  },
  text: {
    flex: '1 1 40px',
    alignSelf: 'center',
    fontSize: 20,
    fontWeight: 'typography.fontWeightLight',
    color: grey['800']
  },
  number: {
    display: 'block',
    fontWeight: 'typography.fontWeightMedium',
    fontSize: 18,
    color: grey['800']
  }
};

class MenuBox extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      test: null
    };
  }

  render() {
    const {color, title, value, icon, onClick, classes} = this.props;
    const extras = {
      span:{backgroundColor: color}
    };
    const Icon = getIcon(icon);
    return (
      <Paper sx={{...s.paper}}>
        <Button onClick={onClick} sx={{...s.button}}>
          <Box style={{width:'100%'}}>
            <Box component='span' className={classNames(classes.iconSpan,extras.span)} style={extras.span}>
              <Icon color={'inherit'} sx={{...s.icon}} />
            </Box>

            <Box sx={{...s.content}}>
              <Box component='span' sx={{...s.text}}>{title}</Box>
              <Box component='span' sx={{...s.number}}>{value}</Box>
            </Box>
          </Box>
        </Button>
      </Paper>
      );
  }
}

MenuBox.propTypes = {
  Icon: PropTypes.any, // eslint-disable-line
  color: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any
};

// export default InfoBox;
export default MenuBox;
